module.exports = __webpack_public_path__ + "img/fz-3.127b0fbf.png";